import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import HomePage from './pages/HomePage';
import WorkflowDetailPage from './pages/WorkflowDetailPage';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import 'antd/dist/reset.css';

const App = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Routes>
          {/* 登录页面 - 公开访问 */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* 首页 - 需要认证 */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          
          {/* 工作流详情页 - 需要认证 */}
          <Route
            path="/workflow/:workflowNum"
            element={
              <ProtectedRoute>
                <WorkflowDetailPage />
              </ProtectedRoute>
            }
          />
          
          {/* 其他路径重定向到首页 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default App; 